import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService, RoutingService, User } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CartDetailsComponent } from '@spartacus/cart/base/components';
import { ActiveCartService, CartConfigService, SelectiveCartService } from '@spartacus/cart/base/core';
import { UigCartGroupingService } from '../uig-cart-grouping/uig-cart-grouping.service';

@Component({
    selector: 'app-uig-cart-details',
    templateUrl: './uig-cart-details.component.html',
    styleUrls: ['./uig-cart-details.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigCartDetailsComponent extends CartDetailsComponent implements OnInit, OnDestroy {

  isRestricted: boolean = false;
  RIO_CART_ORDER: string = "rio_cart_order";
  RIO_CART_CREATE_UPDATE: string = "rio_cart_create_update";
  roles: string[];
  vendorEntryGroups$: Observable<any[]>;
  private userSubscription = new Subscription();

  constructor(
    protected activeCartService: ActiveCartService,
    protected selectiveCartService: SelectiveCartService,
    protected authService: AuthService,
    protected routingService: RoutingService,
    protected userAccountFacade: UserAccountFacade,
    protected cartConfig: CartConfigService,
    protected uigCartGroupingService: UigCartGroupingService
  ) {
    super(activeCartService, selectiveCartService, authService, routingService, cartConfig);
    this.checkForRoles();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.vendorEntryGroups$ = this.cart$.pipe(map((cart) => {
      return this.uigCartGroupingService.groupByVendor(cart.entries, cart.groupSums);
    }))
  }

  ngOnDestroy(): void {
    this.userSubscription.unsubscribe();
  }

  checkForRoles() {
    this.userAccountFacade
      .get()
      .pipe(filter((user: User) => user && Object.keys(user).length > 0))
      .subscribe((user) => {
        const hasRole =
          user.roles && (user.roles.includes(this.RIO_CART_CREATE_UPDATE)
            || user.roles.includes(this.RIO_CART_ORDER));
        if (!hasRole) {
          this.isRestricted = true;
        }
      });
  }
}
